/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'components/common/Button';
import { getCurrencyCode, getMinimumFractionDigits } from 'utils/helpers';

const propTypes = {
  isWithdrawalSuccess: PropTypes.bool,
  isWithdrawalError: PropTypes.bool,
  withdrawalStatusCode: PropTypes.string,
  onCancelClick: PropTypes.func,
  onConfirmationClick: PropTypes.func,
  bankAccount: PropTypes.string,
  withdrawalAmount: PropTypes.any,
  intl: PropTypes.object.isRequired,
};

const WithdrawalFeedback = (props) => {
  if (props.isWithdrawalSuccess) {
    return (
      <div className="withdrawal-feedback withdrawal-feedback--success">
        <div className="withdrawal-feedback__content">
          <h3 className="withdrawal-feedback__title">
            <FormattedMessage id="selfservice.withdrawalConfirmation.successTitle" />
          </h3>
          <p>
            <FormattedMessage
              id="selfservice.withdrawalConfirmation.successText"
              values={{
                amount: (
                  <FormattedNumber
                    style="currency"
                    currency={getCurrencyCode()}
                    value={props.withdrawalAmount}
                    minimumFractionDigits={getMinimumFractionDigits(props.withdrawalAmount, 2)}
                    maximumFractionDigits={2}
                  />
                ),
                account: <strong>{props.bankAccount}</strong>,
              }}
            />
          </p>
          <div className="btn-group">
            <Button btnType="secondary" type="button" onClick={props.onCancelClick}>
              <FormattedMessage id="selfservice.withdrawalConfirmation.close" />
            </Button>
          </div>
        </div>
      </div>
    );
  } if (props.isWithdrawalError) {
    const { withdrawalStatusCode, intl } = props;
    const defaultErrorTitle = intl.formatMessage({ id: 'selfservice.withdrawalConfirmation.errorTitle' });
    const defaultErrorText = intl.formatMessage({ id: 'selfservice.withdrawalConfirmation.errorText' });
    const withdrawalFeedbackClasses = cx({
      'withdrawal-feedback': true,
      'withdrawal-feedback--error': true,
      'withdrawal-feedback--country-fi': COUNTRY === 'FI',
    });

    return (
      <div className={withdrawalFeedbackClasses}>
        <div className="withdrawal-feedback__content">
          <h3 className="withdrawal-feedback__title">
            <FormattedMessage
              id={`selfservice.withdrawalConfirmation.errorTitle.${withdrawalStatusCode}`}
              defaultMessage={defaultErrorTitle}
            />
          </h3>
          <p>
            <FormattedMessage
              id={`selfservice.withdrawalConfirmation.errorText.${withdrawalStatusCode}`}
              defaultMessage={defaultErrorText}
            />
          </p>
          <div className="btn-group">
            <Button btnType="secondary" type="button" onClick={props.onCancelClick}>
              <FormattedMessage id="selfservice.withdrawalConfirmation.cancel" />
            </Button>
            <Button type="button" onClick={props.onConfirmationClick}>
              <FormattedMessage id="selfservice.withdrawalConfirmation.tryAgain" />
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div />
  );
};

WithdrawalFeedback.propTypes = propTypes;

export default injectIntl(WithdrawalFeedback);
